export const shippingAddressData = {
  name: 'Tsamina Mina',
  phoneNumber: '+8801234567890',
  emailAddress: 'tsaminamina@gmail.com',
  country: 'United States',
  state: 'Pennsylvania',
  city: 'Essington',
  street: '500 Powhattan Ave',
  zip: '19029',
  addressType: 'Office',
};

export const billingAddressData = {
  name: 'Megumi Fushigoro',
  phoneNumber: '+8800987654321',
  emailAddress: 'megumifushigoro@gmail.com',
  country: 'United Kingdom',
  state: 'London',
  city: 'Birmingham',
  street: '200 Street',
  zip: '12222',
  addressType: 'Office',
};
